(function($){

	$(document).ready(function(){
		
		/* var counterUp = window.counterUp["default"];
		var $counters = $(".countNum");

		$counters.each(function (ignore, counter) {
			counterUp(counter, {
				duration: 1200,
				delay: 20
			});
		}); */


		var statistics = $(".js-num");

		statistics.each(function(index) {
			// Find the value we want to animate (what lives inside the p tags)
			var value = $(statistics[index]).html();
			// Start animating
			var statisticAnimation = new CountUp(statistics[index], 0, value, 0, 3);
			statisticAnimation.start();
		}); 

		
	});


	
})(jQuery);